'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (dateParts) {
  var _dateParts = _slicedToArray(dateParts, 7),
      year = _dateParts[0],
      month = _dateParts[1],
      day = _dateParts[2],
      hour = _dateParts[3],
      minute = _dateParts[4],
      second = _dateParts[5],
      millies = _dateParts[6];

  if (year != null && year < 0) return new Date('invalid');
  if (month != null && (month < 0 || month > 11)) return new Date('invalid');
  if (day != null && (day < 0 || day > 31)) return new Date('invalid');
  if (hour != null && (hour < 0 || hour > 23)) return new Date('invalid');
  if (minute != null && (minute < 0 || minute > 59)) return new Date('invalid');
  if (second != null && (second < 0 || second > 59)) return new Date('invalid');
  if (millies != null && (millies < 0 || millies > 999)) return new Date('invalid');
  return new Date(Date.UTC.apply(Date, _toConsumableArray(dateParts)));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/of.js
// module id = 1371
// module chunks = 0 1 2 3 4 5 7 8 9